import { c as _c } from "react/compiler-runtime";
import { IcoAmex16, IcoCreditcard16, IcoDiners16, IcoDiscover16, IcoJcb16, IcoMastercard16, IcoUnionpay16, IcoVisa16, IcoVisaelectron16 } from '@onefootprint/icons';
import { motion } from 'framer-motion';
import type { JSX } from 'react';
type CardIconProps = {
  issuer?: string;
};
const cardIcons: Record<string, JSX.Element> = {
  amex: <IcoAmex16 />,
  dinersclub: <IcoDiners16 />,
  discover: <IcoDiscover16 />,
  jcb: <IcoJcb16 />,
  mastercard: <IcoMastercard16 />,
  master_card: <IcoMastercard16 />,
  unionpay: <IcoUnionpay16 />,
  visa: <IcoVisa16 />,
  visaelectron: <IcoVisaelectron16 />
};
const CardIcon = t0 => {
  const $ = _c(2);
  const {
    issuer
  } = t0;
  let t1;
  if ($[0] !== issuer) {
    t1 = issuer ? <motion.div className="flex items-center h-full" aria-label={issuer} key={issuer} role="img">{cardIcons[issuer] && cardIcons[issuer]}</motion.div> : <motion.div className="flex items-center h-full"><IcoCreditcard16 /></motion.div>;
    $[0] = issuer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CardIcon;